module.exports = __webpack_public_path__ + "media/svg/ci-91bd6554.svg";